<template>
  <div class="space-y-5">
    <!-- Section header -->
    <div class="flex items-center gap-3">
      <span
        class="flex items-center justify-center w-9 h-9 rounded-lg bg-taxiye-100 text-taxiye-500"
      >
        <span class="material-icons-round">route</span>
      </span>
      <h3 class="text-base font-semibold text-gray-800">Trips</h3>
    </div>

    <!-- Filters + stats -->
    <v-date-picker v-model="range" is-range timezone="UTC">
      <template v-slot="{ inputValue, inputEvents }">
        <div class="flex flex-wrap items-center justify-between gap-4">
          <div class="flex items-center gap-2">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              placeholder="From Date"
              class="w-32 h-10 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
            />
            <span class="text-gray-400 material-icons-round"
              >arrow_forward</span
            >
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              placeholder="To Date"
              class="w-32 h-10 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
            />
          </div>
          <div class="flex items-center gap-3">
            <div class="px-4 py-2 border border-gray-200 rounded-xl bg-gray-50">
              <p class="text-xs text-gray-500">Number of Trips</p>
              <p class="text-2xl font-semibold text-gray-800">
                {{ corporateTrips.length }}
              </p>
            </div>
            <div class="px-4 py-2 border border-gray-200 rounded-xl bg-gray-50">
              <p class="text-xs text-gray-500">Cost</p>
              <p class="text-2xl font-semibold text-gray-800">{{ fareSum }}</p>
            </div>
          </div>
        </div>
      </template>
    </v-date-picker>

    <!-- Table -->
    <div
      class="overflow-hidden bg-white border border-gray-200 shadow-sm rounded-2xl"
    >
      <div class="overflow-x-auto">
        <table class="min-w-full">
          <thead>
            <tr>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
              >
                Ticket
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
              >
                Driver Name
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
              >
                Employee
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
              >
                Pick / Drop Address
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
              >
                Date
              </th>
              <th
                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-500 uppercase bg-gray-50 border-b border-gray-200"
              >
                Trip Fare
              </th>
            </tr>
          </thead>
          <tbody v-if="corporateTrips.length">
            <tr
              v-for="trip in corporateTrips"
              :key="trip._id"
              class="transition-colors hover:bg-gray-50"
            >
              <td
                class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100"
              >
                {{ trip.ticket ? trip.ticket.code : "-" }}
              </td>
              <td
                class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100"
              >
                {{ trip.driver.firstName + " " + trip.driver.lastName }}
              </td>
              <td
                class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100"
              >
                {{
                  trip.employee
                    ? `${trip.employee.name} (${trip.employee.phone})`
                    : "-"
                }}
              </td>
              <td
                class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100"
              >
                <div class="flex items-center space-x-2">
                  <span class="text-base text-green-600 material-icons-round"
                    >location_on</span
                  >
                  <span>{{ trip.pickUpAddress.name }}</span>
                </div>
                <div class="flex items-center mt-1 space-x-2">
                  <span class="text-base text-red-600 material-icons-round"
                    >location_on</span
                  >
                  <span>{{ trip.dropOffAddress.name }}</span>
                </div>
              </td>
              <td
                class="px-5 py-4 text-sm text-gray-700 border-b border-gray-100"
              >
                <p class="whitespace-no-wrap">
                  {{ formatDate(trip.pickupTimestamp) }}
                </p>
                <p class="mt-1 text-gray-500 whitespace-no-wrap">
                  {{ formatDate(trip.endTimestamp) }}
                </p>
              </td>
              <td
                class="px-5 py-4 text-sm font-medium text-gray-800 border-b border-gray-100 whitespace-no-wrap"
              >
                {{ trip.fare }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7" class="px-5 py-12 text-center">
                <div
                  v-if="loading"
                  class="flex flex-col items-center text-gray-400"
                >
                  <span class="text-5xl material-icons-round spin">sync</span>
                  <span class="mt-2 text-sm">Loading...</span>
                </div>
                <div v-else class="flex flex-col items-center text-gray-400">
                  <span class="text-5xl material-icons-round">route</span>
                  <span class="mt-2 text-sm">No latest rides!</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
// import moment from "moment";
export default {
  props: ["corporate"],
  data() {
    return {
      corporates: [],
      corporateTrips: [],
      range: {
        start: null,
        end: null,
      },
      loading: false,
    };
  },
  computed: {
    fareSum() {
      return this.corporateTrips.length
        ? this.corporateTrips
            .map(trip => trip.fare)
            .reduce((fare, current) => fare + current)
            .toFixed(2)
        : 0;
    },
  },
  watch: {
    corporate() {
      this.getCorporateTrips();
    },
    range: {
      deep: true,
      handler() {
        this.getCorporateTrips();
      },
    },
  },
  created() {
    this.getCorporateTrips();
  },
  methods: {
    getCorporateTrips() {
      // console.log(this.corporate);
      // this.$misc
      //   .get(`/corporates/${this.corporate._id}/trips`)
      //   .then((response) => (this.corporateTrips = response.data))
      //   .catch((err) => console.log(err));
      const { range } = this;
      let url = `/corporates/${this.corporate._id}/trips?populate=["driver", "passenger", "ticket"]`;

      if (range.start) url += `start=${new Date(range.start).toISOString()}`;
      if (range.end) url += `&end=${new Date(range.end).toISOString()}`;

      this.loading = true;
      this.$http
        .get(url)
        .then(response => {
          this.corporateTrips = response.data.data;
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    formatDate(date) {
      // return moment(date).format("MMM D, YYYY HH:mm");
      return date ? date.replace("T", " ").slice(0, 16) : "-";
    },
  },
};
</script>
